import React, { useState } from "react"
import * as R from 'ramda'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import clsx from "clsx"

const estilosPainel = require('./painel.module.scss').default
const estilosBotoes = require('app/estilos/botoes.module.scss').default

export type PainelProps = {
    titulo: string
    conteudo: React.JSX.Element
    mostrarPorPadrao?:boolean
    botoesTitulo?:{
        nome: string,
        icone: IconProp,
        acao: () => void
    }[]
    
}

export const Painel = (props: PainelProps) => {

    const [mostrarConteudo, setMostrarConteudo] = useState(props.mostrarPorPadrao === true)

    const cabecalho = <div className={clsx(estilosPainel.cabecalho, "_flex _flex-row _justify-between")}>
        <a onClick={() => setMostrarConteudo(mostrarConteudo => !mostrarConteudo)}>
            {props.titulo}
        </a>

        {(props.botoesTitulo ?? []).map(botao => 
            <button key={botao.nome} className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
                onClick={() => botao.acao()}>
                <FontAwesomeIcon
                    icon={botao.icone}/>

            </button>)}
    </div>

    const conteudo = <div className={estilosPainel.conteudo}>
        {props.conteudo}
    </div>

    return <div className={estilosPainel.container}>
        {cabecalho}

        {mostrarConteudo && conteudo}
    </div>
}